module.exports = __webpack_public_path__ + "img/3.5108eef2.jpg";